<template>
    <div class="" v-if="!loading && itemsRef.length">
        <carousel
            style="width: 100%"
            ref="myCarousel"
            :breakpoints="breakpoints"
            :settings="settings"
            class="product_slider"
            :wrap-around="true"
        >
            <template #slides>
                <slide v-for="(item, j) in itemsRef" :key="j">
                    <RelatedItem
                        class="carousel__item"
                        :item="item"
                    />
                </slide>
            </template>
            <template #addons>
                <Navigation />
            </template>
        </carousel>
    </div>
    <div class="" v-else>
        <div class="" v-if="loading && !itemsRef.length">
            <carousel
                style="width: 100%"
                ref="myCarousel"
                :breakpoints="breakpoints"
                :settings="settings"
                class="product_slider"
                :wrap-around="true"
            >
                <template #slides>
                    <slide v-for="(item, j) in itemsRef" :key="j">
                        <RelatedItem
                            class="carousel__item"
                            :item="item"
                        />
                    </slide>
                </template>

                <template #addons>
                    <Navigation />
                </template>
            </carousel>
        </div>
        <div class="" v-if="!loading && !itemsRef.length">
            <p class="fs-4 text-center"> No Related Product Found</p>
        </div>
    </div>
</template>

<script setup>
import RelatedItem from "./RelatedItemPrev.vue";
import RelatedItemShimmer from "./RelatedItemShimmer.vue";

import { Carousel, Slide, Pagination, Navigation } from "vue3-carousel";
import "vue3-carousel/dist/carousel.css";

const props = defineProps({
    items: {
        type: Array,
        default: () => [],
    },
    loading: {
        type: Boolean,
        default: false,
    },
});

const settings = ref({
    itemsToShow: 5,
    snapAlign: "start",
});

const breakpoints = ref({
    0: {
        itemsToShow: 1,
        snapAlign: "start",
    },
    300: {
        itemsToShow: 1,
        snapAlign: "center",
    },
    1024: {
        itemsToShow: 2,
        snapAlign: "start",
    },
    1400: {
        itemsToShow: 3,
        snapAlign: "start",
    },
});

const myCarousel = ref(null);

const itemsRef = toRef(props, "items");

</script>

<style lang="scss">
.product_slider {
    .carousel__slide {}

    .carousel__prev,
    .carousel__next {
        width: 40px !important;
        height: 40px !important;
    }

    .carousel__prev {
        margin-left: -2%;
    }

    .carousel__next {
        margin-right: -2%;
    }

    .carousel__prev,
    .carousel__next {
        font-size: 2rem;
        color: #C3B090
    }
}
</style>
